"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _reactRedux = require("react-redux");
var _reduxForm = require("redux-form");
var _buySellSelectors = require("../../../../../redux/selectors/buySellSelectors");
var _orderEntryActions = require("../../../../../redux/actions/orderEntryActions");
var _instrumentPositionSelectors = require("../../../../../redux/selectors/instrumentPositionSelectors");
var _get = _interopRequireDefault(require("lodash/get"));
var _BuySellCustomRowComponent = _interopRequireDefault(require("./BuySellCustomRowComponent"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var mapStateToProps = function mapStateToProps(state) {
  return {
    isBuySide: (0, _buySellSelectors.isBuySideBuySellFormSelector)(state),
    activeAmount: (0, _instrumentPositionSelectors.buySellFormSelector)(state, 'amountRadio'),
    formObj: (0, _get["default"])(state, 'form.buySell', {
      values: {}
    }),
    selectedInstrument: (0, _instrumentPositionSelectors.selectedInstrumentSelector)(state)
  };
};
var mapDispatchToProps = {
  setAmount: function setAmount(amount) {
    return (0, _reduxForm.change)('buySell', 'amountRadio', amount);
  },
  synchronizeQuantityWithPrice: _orderEntryActions.synchronizeQuantityWithPrice,
  synchronizePriceWithQuantity: _orderEntryActions.synchronizePriceWithQuantity
};
var _default = exports["default"] = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_BuySellCustomRowComponent["default"]);